// Course name to slug mapping
export const courseToSlug = (courseName) => {
  return courseName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

// Slug to course name mapping - handles special cases
export const slugToCourse = (slug) => {
  // Special mappings for courses with specific formatting
  const specialMappings = {
    'artificial-intelligence-gen-ai': 'Artificial Intelligence & Gen-AI',
    'devops-sre': 'DevOps & SRE',
    'ui-ux-design': 'UI/UX Design',
    'data-science-with-gen-ai-training': 'Data Science with Gen-AI Training',
    'selenium-automation-training-java-python-c': 'Selenium Automation Training (Java/Python/C#)',
    'cypress-automation-training-javascript': 'Cypress Automation Training (JavaScript)',
    'playwright-automation-training-typescript': 'Playwright Automation Training (TypeScript)',
    'api-testing-training-postman-restassured': 'API Testing Training (Postman + RestAssured)',
    'performance-testing-training-jmeter': 'Performance Testing Training (JMeter)',
    'mobile-automation-training-appium': 'Mobile Automation Training (Appium)',
    'ci-cd-jenkins-training': 'CI/CD Jenkins Training',
    'git-github-training': 'Git & GitHub Training',
    'monitoring-observability-training': 'Monitoring & Observability Training',
    'dot-net-full-stack-training': 'DOT NET Full-Stack Training',
    'c-programming': 'C Programming',
    'c-programming-1': 'C++ Programming',
    'android-app-development-basics': 'Android App Development (Basics)',
    'ai-in-project-management-training': 'AI in Project Management Training',
    'ai-in-excel-training': 'AI in Excel Training',
    'power-platform-low-code-automation': 'Power Platform / Low-Code Automation'
  };

  // Check if there's a special mapping
  if (specialMappings[slug]) {
    return specialMappings[slug];
  }

  // Default: capitalize each word
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
